import type { IDateInputFormat } from '@belong/date-utils';
import { DATE_FORMAT, getDate } from '@belong/date-utils';

export const MINIMUM_REGISTRATION_AGE = 18;
export const MINIMUM_BIRTH_YEAR = 1900;

export const validateFormat = (input: string, format: IDateInputFormat = DATE_FORMAT.INPUT): boolean => {
  return getDate(input, format).isValid();
};

export const dateStringToDate = (dateString: string): Date => {
  const [day, month, year] = dateString.split('/');

  return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
};

export const isFutureDate = (input: string): boolean => {
  return Date.now() < dateStringToDate(input).getTime();
};

export const isNotPastDate = (input: string): boolean => {
  return new Date().setHours(0, 0, 0, 0) <= dateStringToDate(input).getTime();
};

export const validateYear = (input: string): boolean => {
  const [, , year] = input.split('/');

  return window.parseInt(year, 10) >= MINIMUM_BIRTH_YEAR;
};

export const getLastDateOfCurrentMonth = (): Date => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

export const dateIsBeforeOtherDate = (firstDate: string, secondDate: Date): boolean => {
  return dateStringToDate(firstDate) <= secondDate;
};

export const outsideBillingCycle = (input: string): boolean => {
  return dateIsBeforeOtherDate(input, getLastDateOfCurrentMonth());
};

const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const withinSixtyDays = (input: string): boolean => {
  return addDays(new Date(), 60) >= dateStringToDate(input);
};

export const withinDays = (input: string, min: number, max: number): boolean => {
  return (
    addDays(new Date(), min).setHours(0, 0, 0, 0) <= dateStringToDate(input).getTime() &&
    addDays(new Date(), max).setHours(0, 0, 0, 0) >= dateStringToDate(input).getTime()
  );
};
